import React, { useState, useEffect } from 'react';
import * as Yup from "yup";
import ChassisTypeForm from './ChassisTypeForm'
import { Paper, withStyles, Dialog, CircularProgress } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { parseURL } from "../../sc-utilities";
import { connect } from "react-redux";
import * as actions from "./store/chassisTypeActions";
import History from "../../../History";
import { types } from '../../sc-utilities/ChassisType';
import AppLogoLoading from '../../sc-logo';
import {updateKey} from "../TypicalProblem/TypicalProblemForm";

const styles = theme => ({
  root: {
    width: 'auto',
    height: 'auto',
    padding: theme.spacing(2),
    paddingRight: theme.spacing(6),
    margin: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      margin: 0,
      paddingRight: 0,
    }
  },
  submit: {
    backgroundColor: "transparent",
    boxShadow: "none",
    overflow: "hidden",
    alignItems: "center"
  },
  cancel: {
    width: "250px",
    margin: "10px"
  }
});

const ChassisTypeEdit = props => {
  const { chassisType, classes, onFetchChassisTypeInit, activeCustomer, translations, permissions, onFetchChassisType, onEditChassisType } = props;
  const [data, setData] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await onFetchChassisType({ ActiveCustomerID: activeCustomer, PairID: parseURL(window.location.href).pairID })
      setData(false)
    }
    fetchData();
    return () => {
      onFetchChassisTypeInit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async data => {
    let objestToSend = {...data};
    objestToSend['PairID'] = chassisType.PairID;
    if (objestToSend["Key"] === "" || objestToSend["CustomerID"] === 'custom') {
      objestToSend["Key"] = null;
    }
    objestToSend["CustomerID"] === "system" ? objestToSend["CustomerID"] = null    :   objestToSend["CustomerID"] = activeCustomer;
    let result = await onEditChassisType({ ...objestToSend, ActiveCustomerID: activeCustomer });
    if (result) {
      History.goBack()
    }
  }

  let initialValues = {
    TypeKey: chassisType.TypeKey || "",
    TypeValue: chassisType.TypeValue ? chassisType.TypeValue : types.length > 0 ? types[0].value : '',
    CustomerID: chassisType?.CustomerID ? "custom"   :   "system",
    Key: chassisType?.Key ? chassisType.Key : chassisType.TypeKey && chassisType?.CustomerID ? updateKey(chassisType.TypeKey) : '',
  };

  let formSettings = {
    Validation: {
      TypeValue: Yup.string().required("Required"),
      TypeKey: Yup.string().required("Required"),
      CustomerID: Yup.string().required("Required"),
      Key: Yup.string().required("Required"),
    },
    FormTitle: translations['edit_chassis_type'] || 'Edit chassis type',
    ButtonSubmit: hasPermission(permissions, 'system_chassis_type') || (hasPermission(permissions, "chassis_type_save") && chassisType.CustomerID) ? {
      Title: translations["save"] || "SAVE",
      Color: 'primary'
    } : null
  };

  return (
    <Paper className={classes.root} >
      {BackButton(translations)}
      <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data}
        PaperProps={{
          classes: {
            root: classes.submit
          }
        }} >

        <AppLogoLoading />
      </Dialog>
      {!data ?
        <ChassisTypeForm
          formSettings={formSettings}
          initialValues={initialValues}
          handleSubmit={handleSubmit}
          types={types}
          translations={translations}
          permissions={permissions}
          CustomerIDPreviousState={chassisType?.CustomerID ? 'custom'   :   'system'}
          fromEdit={true}
        />
        : <CircularProgress
          variant='determinate'
          color='primary'
          size={28}
        />}
    </Paper>)
}

const mapStateToProps = state => {
  return {
    activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
    permissions: state?.core?.login?.permissions || [],
    chassisType: state.setting.chassisTypes && state.setting.chassisTypes.loaded ? state.setting.chassisTypes.loaded : {},
    translations:
      state.translate && state.translate.translations
        ? state.translate.translations.activeTranslations || {}
        : {},

  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchChassisTypeInit: chassisType => dispatch(actions.loadChassisTypeInit(chassisType)),
    onFetchChassisType: chassisType => dispatch(actions.loadChassisType(chassisType)),
    onEditChassisType: chassisType => dispatch(actions.editChassisType(chassisType)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ChassisTypeEdit));
